import UserRegisterDetailPage from "./user-register-detail-page";

export default UserRegisterDetailPage;
